import Helpers from './helpers';

export interface ISiteFont {
	family: string;
	fileName: string;
	weight: string;
}

const siteFonts: { [site: string]: ISiteFont } = {
	TapWarehouse: { family: 'Source Sans Pro', fileName: 'fonts/source-sans-pro/source-sans-pro-v14-latin-regular.woff2', weight: '400' },
	Drench: { family: 'BrandonTextWeb-Regular', fileName: 'fonts/brandontext/BrandonTextWeb-Regular/font.woff2', weight: '400' },
	Toasty: { family: 'Poppins', fileName: 'fonts/poppins/poppins-v23-latin-regular.woff2', weight: '400' }
};

export default class SiteFonts {

	static getFont(): ISiteFont | null {
		return siteFonts[Helpers.activeSite()] || null;
	}

}
